export default __webpack_public_path__ + "pdf/helloworld.831f7ff.pdf";